export class GradeStatementScenarioType {
    readonly gradeScenarioTypeGD: string = 'GD';
    readonly gradeScenarioTypeIncomplete: string = 'Incomplete';

    readonly incompleteScenarioChangeFromFOrNC: any = {
        statement: 'IncompleteScenarioChangeFromFOrNC',
        gradeType: 'Incomplete'
    };
    readonly incompleteScenarioBeforeFirstSubmitGrade: any = {
        statement: 'IncompleteScenarioBeforeFirstSubmitGrade',
        gradeType: 'Incomplete'
    };
    readonly incompleteScenarioExtDateAfterToday: any = {
        statement: 'IncompleteScenarioExtDateAfterToday',
        gradeType: 'Incomplete'
    };
    readonly incompleteScenarioExtDateBeforeToday: any = {
        statement: 'IncompleteScenarioExtDateBeforeToday',
        gradeType: 'Incomplete'
    };
    readonly gdGradeScenarioInitialGrade: any = {
        statement: 'GDGradeScenarioInitialGrade',
        gradeType: 'GD',
        comment: 'Pending Charge of Academic Integrity'
    };

    static getInstance(): GradeStatementScenarioType {
        return new GradeStatementScenarioType();
    }
}
